import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { QUERY_KEYS } from "../../../../../consts/api";
import { uiNotification } from "../../../../../services/UINotificationService";

export const usePfiIframe = (onClose) => {
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(null);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("");
  const queryClient = useQueryClient();

  useEffect(() => {
    const handler = (event) => {
      if (event.origin !== "https://qa.patientfi.net") return;

      switch (event.data.type) {
        case "aesthetic-records-loading":
          setIsLoading(event.data.data.isLoading);
          break;

        case "aesthetic-records-success":
          uiNotification.success(event.data.data.message);
          onClose();
          queryClient.invalidateQueries([QUERY_KEYS.patientFi.getIntegration]);
          break;

        case "aesthetic-records-error":
          uiNotification.error(event.data.data.message);
          break;

        case "aesthetic-records-enrollment-progress":
          break;

        case "aesthetic-records-enrollment-success":
          setProgress(100);
          onClose();
          queryClient.invalidateQueries([QUERY_KEYS.patientFi.getIntegration]);
          uiNotification.success(event.data.data.message);
          break;

        case "aesthetic-records-enrollment-error":
          setStatus("error");
          setMessage(event.data.data.error);
          uiNotification.error(event.data.data.message);
          break;

        default:
          break;
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  return { isLoading, progress, status, message };
};
